import { get, put } from "../client";
import { GET_PROFILE, UPDATE_PROFILE } from "../routes";

export default {
  get: async () => await get(GET_PROFILE),

  update: async (data) => await put(UPDATE_PROFILE, data),
};
